import axios from 'axios';
import config from '@assets/config.json'; // api 请求json 

const state = {
}
const mutations = {
}
const getters = {
}
const actions = { 
    addDown({ rootState }, opt) { // 新增下载
        return new Promise((resolve, reject) => {
            axios.post(`${config.api.reqApi}/api/Download`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getDownByExhibition({ rootState }, id) { // 根据展会获取下载中心的数据
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/Download/GetByExhibition?exhibitionId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    delDown({ rootState }, id) { // 删除下载
        return new Promise((resolve, reject) => {
            axios.delete(`${config.api.reqApi}/api/Download?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err.response.data);
            });
        });
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
} 